module.exports = __webpack_public_path__ + "img/card-dog-1.576a1052.png";